import React from 'react';
import {useSession} from '@src/Providers/SessionProvider/SessionProvider';
import SessionAlert from './SessionAlert';

const SessionAlertProvider = () => {
  const {isSessionAlertOpen, setIsSessionAlertOpen} = useSession();

  return (
    <SessionAlert
      isOpen={isSessionAlertOpen}
      onClose={() => setIsSessionAlertOpen(false)}
    />
  );
};

export default SessionAlertProvider;
